import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";


/**
 * バッジコンポーネント。
 */

interface Props {
	/**
	 * 新着投稿バッジ表示日数
	 */
	postDate: string;

	/**
	 * 新着投稿バッジ文言
	 */
	newArrivalBadgeText: string;

	/**
	 * 新着投稿バッジ表示日数
	 */
	newArrivalBadgeDisplayDays: number;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    postDate: { type: String, required: true },
    newArrivalBadgeText: { type: String, required: true },
    newArrivalBadgeDisplayDays: { type: Number, required: true }
  },
  setup(__props: any, { expose }) {
  expose()

const props = __props as {
	/**
	 * 新着投稿バッジ表示日数
	 */
	postDate: string;

	/**
	 * 新着投稿バッジ文言
	 */
	newArrivalBadgeText: string;

	/**
	 * 新着投稿バッジ表示日数
	 */
	newArrivalBadgeDisplayDays: number;
}


const isNew = computed(() => {
	const postDate = new Date(props.postDate);
	postDate.setHours(0, 0, 0, 0);
	const targetDate = new Date(Date.now());
	targetDate.setDate(targetDate.getDate() - props.newArrivalBadgeDisplayDays);
	targetDate.setHours(0, 0, 0, 0);

	return targetDate < postDate;
});

const __returned__ = { props, isNew }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})